import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export type EntryPointParams = {};

export const entryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() =>
			import(
				/* webpackChunkName: "@atlaskit-internal_edition-awareness-premium-popup-dialog" */ './dialog'
			),
		{
			moduleId: 'edition-awareness-premium-popup-dialog',
		},
	),
	getPreloadProps: (props: EntryPointParams) => ({
		entryPoints: {},
		extraProps: {},
		queries: {},
	}),
});
